<div class="container">
  <div [innerHtml]="message" class="text"></div>
  <div class="btn-container">
    <button (click)="onAgree()" color="primary" mat-raised-button>{{ 'general.yes' | translate }}</button>
    <button (click)="onDisagree()" color="primary" mat-raised-button>{{ 'general.no' | translate }}</button>
  </div>
</div>
